import { render, staticRenderFns } from "./activity_bargain.vue?vue&type=template&id=0c5fddb1"
import script from "./activity_bargain.vue?vue&type=script&lang=js"
export * from "./activity_bargain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports